<template>
  <base-spinner :open="isloading"></base-spinner>

    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <base-message
        v-if="!isloading"
        :servermessages="servermessages"
        ></base-message>
        <div class="card">
            <div class="card-header">
                <h5>Saved Qwik Orders</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table>
                        <thead>
                            <tr>
                                <th>Saved Qwik Orders</th>
                                <th>Items</th>
                                <th>Total</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <saved-ordered-item 
                            v-for="(savedorder, index) in displayCurrPage"
                            :key="savedorder.ordernumber"
                            :index="index"
                            :savedorderdata="savedorder"
                            @remove-item="removeItem"
                            @add-to-cart="addToCart"
                            >
                            </saved-ordered-item>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-divider"></div>
            <div class="card-footer">
                <base-pagination
                    v-if="this.savedOrders.length > 0"
                    :perPage="perPage"
                    :pages="pages"
                    :currentPage="page"
                    @updatePage="updatePage">
                </base-pagination>
            </div>
        </div>
    </div>

    <base-dialog title="Confirm Delete" @close="cancelRemove" :open="selectedOrderNumber != null">
        <template #default>
            <p>Are you sure you want to remove this order item?</p>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-secondary" @click="cancelRemove">
                Cancel
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="confirmRemove">
                Ok
            </button>
        </template>
    </base-dialog>

</template>


<script>
import axiosvl from "../../../axios/axios-vl.js";
import SavedOrderedItem from './SavedOrderedItem.vue';
import MixinCart from '../../../mixins/cart.js';
import BasePagination from "../../base/BasePagination.vue";

export default {
    components: { SavedOrderedItem, BasePagination },
    mixins : [
        MixinCart
    ],
    data() {
        return {
            // pagination properties
            page: 1,
            perPage: 10,
            pages: [],

            selectedOrderNumber: null,
            savedOrders : [],
            isloading: false,
            servermessages: []
        };
    },

    computed: {
        displayCurrPage() {
            return this.paginate(this.savedOrders);
        },
    },
    methods: {
        paginate(savedOrders) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;

            return savedOrders.slice(from, to);
        },

        total_items(total) {
            console.log('saved order : '+ total);
            this.total_results = total;
            this.pages = [];
            let numberOfPages = Math.ceil(this.total_results / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },

        getSavedOrders(resetMessages) {
            this.savedOrders = [];
            this.isloading = true;

            if (resetMessages) {
                this.servermessages = [];
            }

            axiosvl.post(this.$store.getters['api/get_saved_order_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];

                if (!resetMessages) {
                    messages = this.servermessages;
                }

                if (fields.RESULTCOD.value === 'OK') {
                    const results = [];

                    for (const key in response.data.webroutine.lists.SORDERS.entries) {
                        const obj = response.data.webroutine.lists.SORDERS.entries[key];
                        results.push({
                            savedorderlineentry: obj.SORDERL,
                            year: obj.EHOEYR,
                            month: obj.EHOEMO,
                            day: obj.EHOEDY,
                            time: obj.EHOETM,
                            hour: obj.ORDTH,
                            minute: obj.ORDTM,
                            ordernumber: obj.EHORDNUM,
                            purchaseorder: obj.EHPONO,
                        });
                    }
                    this.savedOrders = results;

                    // build the pagination base on the total results
                    this.total_items(this.savedOrders.length);
                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },

        updatePage(currentPage) {
            this.page = currentPage;
        },

        removeItem(ordernumber) {
            this.selectedOrderNumber = ordernumber;
        },

        confirmRemove() {
            this.isloading = true;
            this.servermessages = [];

            axiosvl.post(this.$store.getters['api/delete_saved_order_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "EHORD#": {"value": this.selectedOrderNumber }
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                const messages = [];

                const wrmessages = response.data.webroutine.messages;

                for (var i = 0; i < wrmessages.length; i++) {
                    messages.push(wrmessages[i]);
                }

                // Return code is not "OK" but no messages appear, add a custom error message
                if (fields.RESULTCOD.value === 'OK' && messages.length === 0) {
                    messages.push("Something went wrong. Please try again later.");
                }

                this.servermessages = messages;

                if (fields.RESULTCOD.value === 'OK') {
                   this.getSavedOrders(false);
                } else {
                    this.isloading = false;
                }

            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });

            this.selectedOrderNumber = null;
        },

        cancelRemove() {
            this.selectedOrderNumber = null;
        },

        addToCart(selorder) {
            this.isloading = true;
            this.$store.dispatch("message/clearKeyedMessage", "SavedOrderResults");

            axiosvl.post(this.$store.getters['api/get_saved_order_parts_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "EHORD#": {"value": selorder}
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                let errorcount = 0, successcount = 0;
                let messages = [];
                // let storedmessages = [];

                if (fields.RESULTCOD.value === 'OK') {

                    
                    for (const key in response.data.webroutine.lists.MPARTSO.entries) {
                        const obj = response.data.webroutine.lists.MPARTSO.entries[key];

                        let productData = {
                            ID : obj.EIITMC,
                            item: obj.EIITMC,
                            desc: obj.IMDESC,
                            manufacturer: obj.EIMFGC,
                            image: obj.EPIMG1,
                            quantity: obj.EKOQTY,
                            listprice: obj.EILSTP,
                            corecharge: obj.EICORP,
                            yourprice: obj.EIEXCP,
                            shipping: 0,
                            linetotal: (obj.EILSTP * obj.EKOQTY),
                            stockquantity: obj.QTYAVL
                        }

                        let validationresult = this.addToCartValidation(productData);

                        if (validationresult.status === 'OK') {
                            successcount++;
                            this.$store.dispatch("cart/addToCart", productData);
                        } else {
                            errorcount++;
                            // storedmessages.push(validationresult.message);
                            messages.push(validationresult.message)
                        }
                    }

                    if (errorcount > 0) {
                        if (successcount > 0) {
                            messages.push('Remaining items have been added to your cart.');
                        }
                    } else {
                        messages.push('Saved order items have been added to your cart.');
                    }

                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },
    },
    created() {
        this.getSavedOrders(true);
    }
}
</script>